$(document).ready(function () {

  var currentDate = new Date();
  setTimeout(function () {
    $(".grid-item-product").each(function () {
      var createdDate = new Date($(this).data("created"));
      var diffDays = Math.ceil(Math.abs(currentDate - createdDate) / 86400000);

      if (diffDays > 60) {
        $(this).find(".grid-product__tag--custom").remove();
      } else {
        $("a", this).before(
          "<div class='grid-product__tag grid-product__tag--custom'>New</div>"
        );
      }
    });
  }, 5000);

  $(document).on('mouseenter', '#site-nav-item--1', function () {
      var $menu = $('#site-nav-item--1');

  if ($menu.length) {

    var $lastItem = $menu.find('.grid__item').last();

    var $titleBlock = $lastItem.find('.h5'); // title
    var $imageLink = $lastItem.find('> div:not(.h5) a'); // image text link

    // duplicate check
    if ($lastItem.find('img.megamenu__collection-image').length) return;

    var text = $imageLink.text().replace(/"/g, '').trim();

    if (text.indexOf('Image--') !== -1) {

      var imageUrl = text.split('Image--')[1].trim();

      var $imgWrapper = $('<div class="svg-mask svg-mask--landscape"></div>');
      var $img = $('<img>', {
        src: imageUrl,
        class: 'megamenu__collection-image',
        alt: 'All Collections'
      });

      $imgWrapper.append($img);
      $titleBlock.before(
        $('<a>', {
          href: $imageLink.attr('href')
        }).append($imgWrapper)
      );
      $imageLink.parent().remove();
    }
  }

    });

    $(document).on('click', '.mobile-nav__item', function () {

  var $menu = $('#Sublinklist-collections-new-printed-hijabs1-collections5');

  if (!$menu.length) return;

  var $link = $menu.find('a.mobile-nav__link');

  $link.each(function () {

    var $this = $(this);

    // duplicate prevent
    if ($this.find('img').length) return;

    var text = $this.text().replace(/"/g, '').trim();

    if (text.indexOf('Image--') !== -1) {

      var imageUrl = text.split('Image--')[1].trim();

      var $img = $('<img>', {
        src: imageUrl,
        class: 'mobile-menu-image',
        alt: 'Collection'
      });

      // replace text with image
      $this.empty().append($img);
    }

  });

});

  function submitForm(event) {
    $(event.target.form).submit();
  }

  $(window).scroll(function () {
    if ($(this).scrollTop() > 20) {
      $("#toTopBtn").show();
    } else {
      $("#toTopBtn").hide();
    }
  });

  $("#toTopBtn").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });

  $(window).scroll(function () {
    if (
      $(document).height() - $(window).height() - $(window).scrollTop() ===
      0
    ) {
      $("#toBottomBtn").fadeOut();
    } else {
      $("#toBottomBtn").fadeIn();
    }
  });

  $("#toBottomBtn").click(function () {
    $("html, body").animate({ scrollTop: $(document).height() }, 1000);
    return false;
  });

  $(document).on("click", ".swatch-view-image .swatch-view-item", function () {
    var value = $(this)
      .attr("orig-value")
      .replace(/[^\w\s]/gi, "");
    value = value.replace(/\s+/g, "-").toLowerCase();
    var styleClass = "style_" + value;
    console.log("Final Class " + styleClass);

    $(".product__thumb-item").each(function () {
      var group = $(this).attr("data-group") || "";
      $(this).toggle(group.toLowerCase() === styleClass);
    });
  });

  $(document).on(
    "click",
    ".swatch-view-custom-image .swatch-view-item",
    function () {
      var value = $(this).attr("orig-value").replace(/\s+/g, "-").toLowerCase();
      var colorClass = "color_" + value;

      $(".product__thumb-item").each(function () {
        var group = $(this).attr("data-group") || "";
        $(this).toggle(group.toLowerCase() === colorClass);
      });
    }
  );

  $(".shopify-currency-form select").on("change", submitForm);

  setTimeout(function () {
    $(".grid-product__colors a").each(function () {
      var bgImage = $(this).css("background-image");
      var colors = {
        "offwhite_50x.png": "#FDF7F4",
        "oat_50x.png": "#E3E1D5",
        "taupe_50x.png": "#9E8A76",
        "rose-dust_50x.png": "#AE9490",
        "peach-pink_50x.png": "#DBBEB7",
        "silver-peony_50x.png": "#C5B3AF",
        "dusty-pink_50x.png": "#C6A4A4",
        "mint-green_50x.png": "#A5B2AA",
        "baby-blue_50x.png": "#9BABBB",
        "sage_50x.png": "#888D82",
        "estate-blue_50x.png": "#36445A",
        "gray_50x.png.png": "#5C525C",
        "silver-cloud_50x.png": "#A09F9C",
        "taupe-gray_50x.png": "#92898A",
        "Capshawl-Duo-DarkGray-1_400x.jpg": "#8D918D",
      };

      $.each(colors, function (key, value) {
        if (bgImage.includes(key)) {
          $(this).css("background-color", value);
        }
      });
    });
  }, 2000);

  setTimeout(function () {
    $(".grid-product__colors a").each(function () {
      var variantImage = $(this).attr("data-variant-image");
      var colors = {
        "Duo-DarkGray": "#8D918D",
        "Duo-Black": "#000000",
        "Duo-LightGray": "#97867c",
        "Duo-Navy": "#000080",
        "Duo-LightPink": "#ffb6c1",
        "Duo-DarkPink": "#AA336A",
        "Duo-White": "#F8F6F0",
        "Duo-Greige": "#f5f5dc",
        "Duo-LightPurple": "#D8BFD8",
        "Duo-DarkPurple": "#301934",
      };

      $.each(colors, function (key, value) {
        if (variantImage.includes(key)) {
          $(this).css("background-color", value);
        }
      });
    });
  }, 2000);

  $(".close-video").click(function () {
    $(this).hide();
    $(".video-img-section video").hide();
  });

  $(".site-header").attr("data-sticky", "true");
  var lastScrollTop = 0;
  $(window).scroll(function () {
    var currentScroll = $(this).scrollTop();
    var header = $(".site-header");

    if (currentScroll > lastScrollTop) {
      header
        .addClass("site-header--stuck site-header--opening")
        .removeClass("scroll-up");
    } else if (currentScroll > 20) {
      header.addClass("site-header--stuck");
    } else {
      header.removeClass("site-header--stuck site-header--opening");
    }

    lastScrollTop = currentScroll;
  });

  // Mothers 2025 Collection Slider Code

  var totalSlides = $(".slide").length;
  var currentIndex = 0;
  var slideInterval; // for auto sliding

  function showSlide(index) {
    $(".slide").removeClass("active");
    $(".slide").eq(index).addClass("active");
  }

  function nextSlide() {
    currentIndex++;
    if (currentIndex >= totalSlides) {
      currentIndex = 0;
    }
    showSlide(currentIndex);
  }

  function prevSlide() {
    currentIndex--;
    if (currentIndex < 0) {
      currentIndex = totalSlides - 1;
    }
    showSlide(currentIndex);
  }

  $(".next").click(function () {
    nextSlide();
    resetInterval();
  });

  $(".prev").click(function () {
    prevSlide();
    resetInterval();
  });

  function startAutoSlide() {
    slideInterval = setInterval(function () {
      nextSlide();
    }, 3000); // 3 seconds
  }

  function resetInterval() {
    clearInterval(slideInterval);
    startAutoSlide();
  }

  // Start auto sliding
  startAutoSlide();

  // Checkout check button function

  setTimeout(function () {
    console.log("Disabled class added by timeout");
    $(".btn.cart__checkout").addClass("disabled-btn").attr("disabled", true);
  }, 5000);

  $(document).on("change", "#CartTerms", function () {
    if ($(this).is(":checked")) {
      console.log("Checkbox checked");
      $(".btn.cart__checkout")
        .removeClass("disabled-btn")
        .removeAttr("disabled");
    } else {
      console.log("Checkbox unchecked");
      $(".btn.cart__checkout").addClass("disabled-btn").attr("disabled", true);
    }
  });

  $(document).on("change", "#CartTermsDrawer", function () {
    if ($(this).is(":checked")) {
      console.log("Checkbox checked");
      $(".btn.cart__checkout")
        .removeClass("disabled-btn")
        .removeAttr("disabled");
    } else {
      console.log("Checkbox unchecked");
      $(".btn.cart__checkout").addClass("disabled-btn").attr("disabled", true);
    }
  });

  $(document).on("click", ".btn.cart__checkout", function (event) {
    if ($(this).hasClass("disabled-btn")) {
      event.preventDefault();
      alert(
        "Please accept the terms and conditions before proceeding to checkout."
      );
    }
  });

  // Style images loading

  // function renderNewImages() {
  //   $(".usf-facet-value--with-background").each(function () {
  //     let bgImage = $(this).css("background-image");

  //     // Extract URL from background-image property
  //     if (bgImage && bgImage !== "none") {
  //       let url = bgImage.replace(/^url\(["']?/, "").replace(/["']?\)$/, "");

  //       // Find an <img> inside the element and set its src attribute
  //       let imgElement = $(this).find("img");
  //       if (imgElement.length > 0) {
  //         imgElement.attr("src", url);
  //       } else {
  //         // If no <img> exists, create one and append it
  //         $(this).append(`<img src="${url}" alt="Background Image">`);
  //       }

  //       // Remove background image
  //       $(this).css("background-image", "none");

  //       console.log(`Background image moved to img tag: ${url}`);
  //     }
  //   });
  // }

  // requestAnimationFrame(function () {
  //   renderNewImages();
  // });

  // Run function on Click

  // $(document).on("click", ".usf-facet-value--with-background", function () {
  //   requestAnimationFrame(() => moveBackgroundToImg($(this)));
  // });

  // function moveBackgroundToImg(element) {
  //   let bgImage = element.css("background-image");

  //   if (bgImage && bgImage !== "none") {
  //     let url = bgImage.replace(/^url\(["']?/, "").replace(/["']?\)$/, "");

  //     let imgElement = element.find("img");
  //     if (imgElement.length > 0) {
  //       imgElement.attr("src", url);
  //     } else {
  //       element.append(`<img src="${url}" alt="Background Image">`);
  //     }

  //     // Remove background image
  //     element.css("background-image", "none");

  //     console.log(`Background image moved to img tag: ${url}`);
  //   }
  // }

  // $(".usf-facet-value--with-background").on("click", function (e) {
  //   console.log("Filter Image Clicked");
  //   requestAnimationFrame(function () {
  //     renderNewImages();
  //   });
  // });

  // $(".usf-clear").on("click", function (e) {
  //   console.log("Clear Single Filter Image");
  //   setTimeout(renderNewImages, 3000);
  // });

  // $(".usf-clear-all").on("click", function (e) {
  //   console.log("Clear All Filter Images");
  //   setTimeout(renderNewImages, 3000);
  // });



});
